export const SUPPORT_EMAIL = 'support@assessment.peardeck.com'
